var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{},[_c('div',{staticClass:"partner-img card-img-top rounded-circle cursor-pointer",style:({
      backgroundImage: 'url(' + _vm.data.imageUrl + ')'
    }),on:{"click":_vm.handleToStore}}),_c('b-card-body',{staticClass:"text-center"},[_c('h4',{staticClass:"card-text cursor-pointer",on:{"click":_vm.handleToStore}},[_vm._v(" "+_vm._s(_vm.data.name)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }